import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Package, LogOut, User } from "lucide-react";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) nav("/login");
  }, [loading, user, nav]);

  useEffect(() => {
    if (user) api.get("/orders/me").then(({data}) => setOrders(data));
  }, [user]);

  if (loading || !user) return <div className="container-x py-20 text-center">Loading…</div>;

  return (
    <div className="container-x py-10" data-testid="account-page">
      <h1 className="font-serif text-4xl md:text-5xl mb-8">My Account</h1>
      <div className="grid md:grid-cols-[260px_1fr] gap-8">
        <aside className="border hairline rounded-xl p-6 bg-white h-fit">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center"><User className="w-5 h-5" strokeWidth={1.5} /></div>
            <div>
              <div className="font-serif text-lg">{user.name}</div>
              <div className="text-xs text-muted-foreground">{user.email}</div>
            </div>
          </div>
          {user.role === "admin" && (
            <Link to="/admin" className="block text-sm py-2 gold-text" data-testid="admin-link">Admin Dashboard →</Link>
          )}
          <button onClick={() => { logout(); nav("/"); }} className="mt-3 text-xs text-muted-foreground hover:text-destructive flex items-center gap-1" data-testid="logout-btn">
            <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} /> Sign out
          </button>
        </aside>
        <div>
          <div className="flex items-center gap-2 mb-4"><Package className="w-4 h-4 gold-text" strokeWidth={1.5} /><div className="font-serif text-2xl">My Orders</div></div>
          {orders.length === 0 ? (
            <div className="border hairline rounded-xl p-8 bg-white text-sm text-muted-foreground text-center">No orders yet.</div>
          ) : (
            <div className="space-y-3">
              {orders.map((o) => (
                <div key={o.order_number} className="border hairline rounded-xl p-4 bg-white" data-testid={`order-${o.order_number}`}>
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="font-medium">{o.order_number}</div>
                      <div className="text-xs text-muted-foreground">{new Date(o.created_at).toLocaleString()}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-serif text-lg">₹{o.total}</div>
                      <div className="text-xs capitalize gold-text">{o.status.replace(/_/g, " ")}</div>
                    </div>
                  </div>
                  <div className="mt-3 flex gap-2 overflow-x-auto">
                    {o.items.map((it) => (<img key={it.product_id} src={it.image} className="w-12 h-12 rounded object-cover" alt="" />))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
